<div class="title-group">
	<div class="title-div">
		<img class="title-div-img" [src]="SelectedImageLibraryItem.ImageLibraryData_Thumb" />
	</div>

	<div class="title-div" style="margin-top: 5px">
		<label>{{ SelectedImageLibraryItem.ImageLibraryItemName }}</label>
	</div>
</div>

<div class="check-list-group">
	<div class="check-list-heading-div">
		<label class="check-list-heading-label">{{ SelectedGroup.ImageLibraryGroupDesc }}</label>
	</div>

	<div class="check-list-scroll-div">
		<div *ngFor="let obj of ImageLibraryAssocList" class="check-list-item">
			<div>
				<input class="check-list-item-check" type="checkbox" name="checkbox-list" [(ngModel)]="obj.IsAssociated" ngDefaultControl />
			</div>

			<div style="margin-left: 10px">
				<label class="check-list-item-label">{{ obj.ImageLibraryAssociationDesc }}</label>
			</div>
		</div>
	</div>
</div>

<div style="margin-top: 20px">
	<button class="btn btn-primary" style="margin-left: 0px" [disabled]="isBusy == true" (click)="onSave()">Save</button>
	<button class="btn btn-primary" style="margin-left: 5px" (click)="onClose()">Cancel</button>
</div>
